import Swiper from "swiper";

export async function glideProductListSmallInit() {
  const elements = document.querySelectorAll(".swiper--product-list-small");

  if (elements.length) {
    elements.forEach((slider) => {
      const gap = 45;
      const swiperContainer = slider.querySelector(".swiper-wrapper");
      const checkOverflow = () => {
        const totalWidth = swiperContainer
          ? Array.from(swiperContainer.children).reduce((sum, item) => {
              return sum + item.offsetWidth;
            }, 0)
          : 0;

        const containerWidth = swiperContainer.offsetWidth;
        if (totalWidth > containerWidth) {
          return true;
        } else {
          return false;
        }
      };

      const swiper = new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: gap,
        loop: true,
        scrollbar: {
          el: ".swiper-scrollbar",
          hide: true,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          0: {
            spaceBetween: 17,
          },
          768: {
            spaceBetween: 17,
          },
          1024: {
            spaceBetween: gap,
          },
        },
      });

      const rightButton = slider.querySelector(".glide__arrow--right");
      if (rightButton) {
        rightButton.addEventListener("click", () => {
          swiper.slideNext();
        });
      }
      const leftButton = slider.querySelector(".glide__arrow--left");
      if (leftButton) {
        leftButton.addEventListener("click", () => {
          swiper.slidePrev();
        });
      }
      slider.addEventListener("mouseover", () => {
        const buttons = slider.querySelectorAll(
          ".glide__arrow--left, .glide__arrow--right"
        );
        const showButtons = checkOverflow();
        if (showButtons) {
          buttons.forEach((btn) => (btn.style.display = "block"));
        }
      });

      slider.addEventListener("mouseout", () => {
        const buttons = slider.querySelectorAll(
          ".glide__arrow--left, .glide__arrow--right"
        );
        buttons.forEach((btn) => (btn.style.display = "none"));
      });
    });
  }
}
